<script>
import i18n from "@/plugins/i18n";
import { SidebarMenu } from 'vue-sidebar-menu';
import { mapActions } from "vuex";

export default {
    components: {
      SidebarMenu,
    },

    data() {
        return {
            collapsed: false,
        }
    },

    computed: {
        menu() { 
            return [
                {
                    icon: "fa-solid fa-bars",
                    class: "toggle-close-navbar"
                },
                {
                    href: '/audited-companies',
                    title: 'Audited Companies',
                    icon: 'fi fi-ss-city',
                },
                {
                    href: '/company',
                    title: i18n.t('companyOperations.companyOperations'),
                    icon: 'fa-solid fa-building-user',
                },
                {
                    href: '/stakeholders',
                    title: i18n.t('sideBar.settings.userCompany'),
                    icon: 'fa-solid fa-users',
                    class: 'navbar-border'
                },
                {
                    href: '/audited-company-profile',
                    title: i18n.t('sideBar.menuTitles.auditedCompanyProfile'),
                    icon: 'fi fi-ss-city',
                },
                {
                    href: '/audit-sdg-alignment',
                    title: i18n.t('auditor.sidebar.sdg') + i18n.t('su2Results.result'),
                    icon: 'fa-solid fa-magnifying-glass-chart',
                },
                {
                    href: '/audit-materiality-analysis',
                    title: i18n.t('auditor.sidebar.materiality') + i18n.t('su2Results.result'),
                    icon: 'fa-solid fa-magnifying-glass-chart',
                },
                {
                    title: i18n.t('sideBar.sustainability.reports'),
                    icon: 'fi fi-sr-memo',
                    href: '/audit-reports',
                },
                {
                    href: '/audit-metrics',
                    title: i18n.t('sideBar.sustainability.kpiMonitor'),
                    icon: 'fa-solid fa-magnifying-glass-chart',
                    class: 'navbar-border'
                },
                {
                    href: '/project-search-engine',
                    title: i18n.t('sideBar.projects.projectSearchEngine'),
                    icon: 'fa-solid fa-magnifying-glass',
                },
            ];
        }
    },

    methods: {
        ...mapActions('app', [
            'setNavbarOpen',
        ]),

        onItemClick(event, item, node) {
            if(item.class == 'toggle-close-navbar'){
                this.collapsed = !this.collapsed;
                this.setNavbarOpen(this.collapsed);
            }
        },
    }
}
</script>

<template>
    <div style="height: 100%;">
        <sidebar-menu 
            :menu="menu" 
            :collapsed="collapsed" 
            :relative="true"
            width="100%"
            widthCollapsed="5em"
            :hideToggle="true"
            :disableHover="true"
            @item-click="onItemClick"
        />
    </div>
    
</template>


<style lang="scss">

.v-sidebar-menu {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    z-index: 999;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    text-align: left;
    -webkit-transition: 0.3s max-width ease;
    transition: 0.3s max-width ease;
    overflow: hidden;
}

.v-sidebar-menu * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}

.v-sidebar-menu .vsm--scroll-wrapper {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden
}

.v-sidebar-menu .vsm--dropdown>.vsm--list {
    padding: 5px !important
}

.v-sidebar-menu .vsm--item {
    position: relative;
    display: block;
    width: 100%;
    white-space: nowrap;
}

.v-sidebar-menu .vsm--link {
    cursor: pointer;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 14px !important;
    font-weight: 400;
    padding: 6px !important;
    line-height: 30px;
    text-decoration: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    z-index: 20;
    -webkit-transition: 0.3s all ease;
    transition: 0.3s all ease
}

.v-sidebar-menu .vsm--link_exact-active,
.v-sidebar-menu .vsm--link_active {
    font-weight: 600;
    background-color: #102734;
}

.v-sidebar-menu .vsm--link_disabled {
    opacity: 0.4;
    pointer-events: none
}

.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
    padding-left: 1em; /* was not present before, added on 26.03.2024 by ata to make the upgrade button look more aligned with the rest of the buttons*/
    height: 30px;
    line-height: 30px;
    width: 30px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    text-align: center;
    border-radius: 3px;
}

.v-sidebar-menu .vsm--icon {
    display: inline-block;
    margin-right: 10px
}

.v-sidebar-menu .vsm--title {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1
}

.v-sidebar-menu .vsm--arrow {
    width: 30px;
    text-align: center;
    font-style: normal;
    font-weight: 900;
    -webkit-transition: 0.3s -webkit-transform ease;
    transition: 0.3s -webkit-transform ease;
    transition: 0.3s transform ease;
    transition: 0.3s transform ease, 0.3s -webkit-transform ease
}

.v-sidebar-menu .vsm--arrow:after {
    content: '\f105';
    font-family: 'Font Awesome 5 Free'
}

.v-sidebar-menu .vsm--arrow_open {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg)
}

.v-sidebar-menu .vsm--arrow_slot:after {
    display: none
}

.v-sidebar-menu .vsm--header {
    font-size: 14px !important;
    font-weight: 600;
    padding: 10px;
    white-space: nowrap;
    text-transform: uppercase
}

.v-sidebar-menu .vsm--badge_default {
    padding: 0px 6px;
    font-size: 14px !important;
    border-radius: 3px;
    height: 20px;
    line-height: 20px;
    font-weight: 600;
    text-transform: uppercase
}

.v-sidebar-menu .vsm--toggle-btn {
    display: block;
    text-align: center;
    font-style: normal;
    font-weight: 900;
    height: 50px;
    cursor: pointer;
    border: none;
    width: 100%;
    padding-left: 6px !important;
}

.v-sidebar-menu .vsm--toggle-btn:after {
    content: '\f337';
    font-family: 'Font Awesome 5 Free'
}

.v-sidebar-menu .vsm--toggle-btn_slot:after {
    display: none
}

.v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover,
.v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover {
    background-color: transparent !important
}

.v-sidebar-menu.vsm_rtl {
    right: 0;
    left: inherit;
    text-align: right;
    direction: rtl
}

.v-sidebar-menu.vsm_rtl .vsm--icon {
    margin-left: 10px !important;
    margin-right: 0px
}

.v-sidebar-menu.vsm_relative {
    position: relative;
    height: 100%
}

.v-sidebar-menu .expand-enter-active,
.v-sidebar-menu .expand-leave-active {
    -webkit-transition: height 0.3s ease;
    transition: height 0.3s ease;
    overflow: hidden
}

.v-sidebar-menu .expand-enter,
.v-sidebar-menu .expand-leave-to {
    height: 0 !important
}

.v-sidebar-menu .slide-animation-enter-active {
    -webkit-transition: width 0.3s ease;
    transition: width 0.3s ease
}

.v-sidebar-menu .slide-animation-leave-active {
    -webkit-transition: width 0.3s ease;
    transition: width 0.3s ease
}

.v-sidebar-menu .slide-animation-enter,
.v-sidebar-menu .slide-animation-leave-to {
    width: 0 !important
}

.v-sidebar-menu .fade-animation-enter-active {
    -webkit-transition: opacity 0.3s ease, visibility 0.3s ease;
    transition: opacity 0.3s ease, visibility 0.3s ease
}

.v-sidebar-menu .fade-animation-leave-active {
    -webkit-transition: opacity 0.3s ease, visibility 0.3s ease;
    transition: opacity 0.3s ease, visibility 0.3s ease
}

.v-sidebar-menu .fade-animation-enter,
.v-sidebar-menu .fade-animation-leave-to {
    opacity: 0 !important;
    visibility: hidden !important
}

.v-sidebar-menu .vsm--mobile-item>.vsm--item {
    padding: 0 !important;
    margin: 0 !important
}

.v-sidebar-menu .vsm--mobile-item>.vsm--item>.vsm--link {
    margin: 0 !important;
    background-color: transparent !important;
    line-height: 30px !important
}

.v-sidebar-menu {
    background-color: #023047 !important
}

.v-sidebar-menu .vsm--link {
    color: #fff
}

.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu .vsm--link_level-1.vsm--link_active {
    -webkit-box-shadow: 3px 0px 0px 0px #054a6d inset !important;
    box-shadow: 3px 0px 0px 0px #054a6d inset !important
}

.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
    background-color: transparent
}

.v-sidebar-menu .vsm--link_hover,
.v-sidebar-menu .vsm--link:hover {
    background-color: rgba(30, 30, 33, 0.5)
}

.v-sidebar-menu .vsm--link_mobile-item {
    color: #023047
}

.v-sidebar-menu .vsm--link_mobile-item.vsm--link_hover,
.v-sidebar-menu .vsm--link_mobile-item:hover {
    color: #023047;
    background-color: rgba(30, 30, 33, 0.5)
}

.v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon,
.v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover .vsm--icon {
    color: #fff;
    background-color: rgba(30, 30, 33, 0.5);
}

.v-sidebar-menu .vsm--dropdown .vsm--list {
    background-color: #043953 !important
}

.v-sidebar-menu .vsm--mobile-bg {
    background-color: #023047 !important
}

.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {
    color: #fff;
    background-color: #023047 !important
}

.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--icon {
    background-color: transparent !important
}

.v-sidebar-menu.vsm_rtl .vsm--link_level-1.vsm--link_active,
.v-sidebar-menu.vsm_rtl .vsm--link_level-1.vsm--link_exact-active {
    -webkit-box-shadow: -3px 0px 0px 0px #023047 inset !important;
    box-shadow: -3px 0px 0px 0px #023047 inset !important
}

.v-sidebar-menu .vsm--header {
    color: rgba(255, 255, 255, 0.7)
}

.v-sidebar-menu .vsm--badge_default {
    color: #fff;
    background-color: #1e1e21 !important
}

.v-sidebar-menu .vsm--toggle-btn {
    color: #fff;
    background-color: #043852 !important
}

.v-sidebar-menu.vsm_white-theme {
    background-color: #fff
}

.v-sidebar-menu.vsm_white-theme .vsm--link {
    color: #262626
}

.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_active {
    -webkit-box-shadow: 3px 0px 0px 0px #4285f4 inset;
    box-shadow: 3px 0px 0px 0px #4285f4 inset
}

.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_exact-active .vsm--icon,
.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_active .vsm--icon {
    color: #fff;
    background-color: #262626
}

.v-sidebar-menu.vsm_white-theme .vsm--link_level-1 .vsm--icon {
    background-color: #bbc5d6
}

.v-sidebar-menu.vsm_white-theme .vsm--link_hover,
.v-sidebar-menu.vsm_white-theme .vsm--link:hover {
    background-color: rgba(242, 242, 242, 0.5)
}

.v-sidebar-menu.vsm_white-theme .vsm--link_mobile-item {
    color: #fff
}

.v-sidebar-menu.vsm_white-theme .vsm--link_mobile-item.vsm--link_hover,
.v-sidebar-menu.vsm_white-theme .vsm--link_mobile-item:hover {
    color: #fff
}

.v-sidebar-menu.vsm_white-theme.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon,
.v-sidebar-menu.vsm_white-theme.vsm_collapsed .vsm--link_level-1:hover .vsm--icon {
    color: #fff;
    background-color: #4285f4
}

.v-sidebar-menu.vsm_white-theme .vsm--dropdown .vsm--list {
    background-color: #e3e3e3
}

.v-sidebar-menu.vsm_white-theme .vsm--mobile-bg {
    background-color: #4285f4
}

.v-sidebar-menu.vsm_white-theme.vsm_expanded .vsm--item_open .vsm--link_level-1 {
    color: #fff;
    background-color: #4285f4
}

.v-sidebar-menu.vsm_white-theme.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--icon {
    background-color: #4285f4
}

.v-sidebar-menu.vsm_white-theme.vsm_rtl .vsm--link_level-1.vsm--link_active,
.v-sidebar-menu.vsm_white-theme.vsm_rtl .vsm--link_level-1.vsm--link_exact-active {
    -webkit-box-shadow: -3px 0px 0px 0px #4285f4 inset;
    box-shadow: -3px 0px 0px 0px #4285f4 inset
}

.v-sidebar-menu.vsm_white-theme .vsm--header {
    color: rgba(38, 38, 38, 0.7)
}

.v-sidebar-menu.vsm_white-theme .vsm--badge_default {
    color: #262626;
    background-color: #f2f2f2
}

.v-sidebar-menu.vsm_white-theme .vsm--toggle-btn {
    color: #262626;
    background-color: #f2f2f2
}

::-webkit-scrollbar{
  margin: 0 !important;
  width: 5px !important;
  background: aliceblue !important;
}
::-webkit-scrollbar-thumb{
  background: #035a86 !important;
}

/*# sourceMappingURL=vue-sidebar-menu.css.map*/



.navbar-border{
    border-bottom: thin solid white !important;
}

.vsm_expanded .toggle-close-navbar .vsm--icon{
    padding-left: 45%; /* ??? */
}
.vsm--link_hover .toggle-close-navbar .vsm--icon{
    padding-left: 45%; /* ??? */
}

.analysis-results-navbar{
    margin-left: 5% !important;
}


.vsm_expanded .upgrade-button {
    border-radius: 2em;
    border: thin solid white;
    width: 10em;
    margin-left: 1em;

    box-shadow: 0 0 .6em .1em white inset;

    &:hover {
        background: linear-gradient(to bottom, var(--sustainfinity-green), var(--sustainfinity-blue));
        box-shadow: 0 0 .6em .1em white;
    }

    > i {
        padding-top: .2em !important;
        padding-left: 0 !important;
    }
}
.vsm_collapsed .upgrade-button .vsm--icon{
    text-align: center;
    border-radius: 1.5em;
    border: thin solid white;
    margin-left: .3em;
    padding-left: 0 !important;

    box-shadow: 0 0 .6em .1em white inset;

    &:hover {
        background-color: 0 !important;
        background: linear-gradient(to bottom, var(--sustainfinity-green), var(--sustainfinity-blue));
        box-shadow: 0 0 .6em .1em white;
    }
}
</style>